import React, { useState, useEffect, useRef } from "react";
import useTable from "../components/useTable";
import { Mensaje, MensajeSiNo } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import moment from "moment";
import { formatMoneda } from "../util/varios";
import { Toasts } from "../components/toasts";
import { SolicitudTimbre } from "../components/timbre_fiscal_electronico/modal_timbre_fiscal_electronico";

function TimbreFiscalElectronico() {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const crudtimbreelectro = JSON.parse(
    localStorage.getItem("crudtimbreelectro")
  );

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tab, setTab] = useState(1);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [activate, setActivate] = useState(false);
  const [solvencia, setSolvencia] = useState(null);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [mostrar2, setMostrar2] = useState(false);
  const [entes, setEntes] = useState([]);
  const [dependencias, setDependencias] = useState([]);
  const [tramites, setTramites] = useState([]);
  const [valorut, setValorut] = useState(0.0);

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONTRIBUYENTE",
      textAlign: "center",
    },
    {
      id: "9",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "USUARIO",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA SOLICITUD",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR UTE",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO A PAGAR",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS PAGO",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS TIMBRE",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idsolicitud.includes(target.value) ||
              x.codigo.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              moment(x.fechasolicitud)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              (x.estatus === 1
                ? "Pagada"
                : x.estatus === 2
                ? "Verificando Pago"
                : "Por Pagar"
              )
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              (x.status === 2 ? "habilitado" : "inhabilitado")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 1)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 1)",
    },
  };

  const imprimirPago = (item) => (event) => {
    event.preventDefault();

    var titulo =
      item.estatussolvencia === 1 ? "Certificado de Pago Electrónico" : "";
    var estatus = item.estatussolvencia === 1 ? "'-2'" : "'0'";
    var certificado = item.estatussolvencia === 1 ? "true" : "false";
    var tipo = item.tipopago === 1 ? "Depo" : "Trans";

    window.open(
      op.reportes +
        "FACTURA=" +
        item.idfactura +
        "&titulo=" +
        titulo +
        "&estatus=" +
        estatus +
        "&certificado=" +
        certificado +
        "&reporte=" +
        tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirSolvencia = (item) => (event) => {
    event.preventDefault();

    if (crudtimbreelectro.substring(1, 2) !== "0") {
      window.open(
        op.reportes +
          "IDSOLICITUD=" +
          item.idsolicitud +
          "&reporte=Electronico",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      setToast({
        ...toast,
        mostrar: true,
        titulo: "Notificación",
        mensaje: "No Posee los Permisos para Realizar esta Acción",
      });
    }
  };

  const seleccionarRegistros = () => {
    let campos = "s.*, (select trim(login) as login from usuarioweb where idusuarioweb=s.idusuarioweb limit 1) as usuario";
    let nomtab = "solicitud_timbre_digital as s";
    let orden = "s.idsolicitud desc";

    let endpoint = `${op.conexion}/api/solicitudtimbre/consultar?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const getValorUTE = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/comunweb/valorpetro`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setValorut(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarEntes = (item) => {
    let campos = `trim(nombre) as nombre, idagente, idtipoente`;
    let nomtab = "agente";
    let condi = `ente=true`;
    let orden = "idagente asc";

    let endpoint = `${op.conexion}/api/consultaweb/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setEntes(response.data);
            Seleccionardependencias(item);
          } else {
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Seleccionardependencias = (item) => {
    let campos = "*";
    let nomtab = "dependencias";
    let nomid = "tipoente";

    let endpoint = `${op.conexion}/api/consultaweb/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${item.idente}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setDependencias(response.data);
            Seleccionartramites(item.iddependencia);
          } else {
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Seleccionartramites = (id) => {
    let campos = "*";
    let nomtab = "tramites";
    let nomid = "iddependencia";

    let endpoint = `${op.conexion}/api/consultaweb/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setTramites(response.data);
            setMostrar2(true);
          } else {
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarRegistro = (item) => {
    let campos = "so.*, d.tipoente";
    let nomtab =
      "solicitud_timbre_digital as so inner join dependencias as d on d.iddependencia=so.iddependencia";
    let nomid = "so.idsolicitud";

    let endpoint = `${op.conexion}/api/solicitudtimbre/consultarid?campos=${campos}&id=${item.idsolicitud}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setSolvencia(response.data);
            SeleccionarEntes(item);
          } else {
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
  };

  const ocultarModal = (p) => {
    if (p === 1) {
      seleccionarRegistros();
    }
    setMostrar2(false);
  };

  const cerrarModal = () => {
    seleccionarRegistros();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const gestionarSolicitud = (op, id) => (e) => {
    e.preventDefault();

    setOperacion(op);
    if (op === 1) {
      if (crudtimbreelectro.substring(1, 2) !== "0") {
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (crudtimbreelectro.substring(2, 3) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (crudtimbreelectro.substring(3, 4) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 4) {
      if (crudtimbreelectro.substring(0, 1) !== "0") {
        seleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    getValorUTE();
  }, []);

  return (
    <div className="">
      <div
        className="p-2 title-table"
        style={{
          fontFamily: "georgia",
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "bold",
        }}
      ></div>
      <div className="container col-md-11 col-12 amanecergris mx-auto">
        <div className="row py-2 col-md-12">
          <div className="col-md-12 mx-auto">
            <ul
              className="nav nav-tabs"
              id="ex-with-icons"
              role="tablist"
              style={{ borderRadius: "3px 3px 0px 0px" }}
            >
              <li
                className="nav-item"
                onClick={() => setTab(1)}
                role="presentation"
              >
                <a
                  className="nav-link bg-danger estilotab p-2"
                  style={tab === 1 ? estilos.tab : {}}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#ex-with-icons-tabs-1"
                  role="tab"
                  aria-controls="ex-with-icons-tabs-1"
                  aria-selected="true"
                >
                  <i className="fas fa-pager fa-fw me-1" />
                  Timbre Electronico
                </a>
              </li>
            </ul>

            <div
              className="tab-content"
              id="ex-with-icons-content"
              style={tab === 1 ? estilos.contenido : {}}
            >
              <div
                className="tab-pane fade show active"
                id="ex-with-icons-tabs-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="card text-center">
                  <div className="card-body">
                    <div className="col-md-12 row was-validated">
                      <div className="row col-12 d-flex justify-content-between">
                        <input
                          type="text"
                          className=" col-3 form-control form-control-sm rounded-pill"
                          ref={txtBuscador}
                          onChange={handleSearch}
                          placeholder="Buscar"
                        />
                    <div className="col-3 d-flex justify-content-end">
                          <button
                            onClick={gestionarSolicitud(1, "")}
                            style={{ marginBottom: "5px" }}
                            className="btn btn-sm btn-primary rounded-circle"
                          >
                            <i className="fas fa-plus"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      {
                        <div className="col-md-12 pt-3">
                          <TblContainer
                            container={{
                              maxHeight: 180,
                              width: "100%",
                              overflow: "auto",
                            }}
                          >
                            <TblHead />
                            <tbody>
                              {records &&
                                recordsAfterPagingAndSorting().map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td
                                        className="align-baseline text-center"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {item.codigo}
                                      </td>
                                      <td
                                        className="align-baseline text-start"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {item.nombre.trim()}
                                      </td>
                                      <td
                                        className="align-baseline text-start"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {item.usuario}
                                      </td>
                                      <td
                                        className="align-baseline text-center"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {moment(item.fechasolicitud).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </td>
                                      <td
                                        className="align-baseline text-end"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {formatMoneda(
                                          item.valorute
                                            .toString()
                                            .replace(",", "")
                                            .replace(".", ","),
                                          ",",
                                          ".",
                                          2
                                        )}
                                      </td>
                                      <td
                                        className="align-baseline text-end"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {formatMoneda(
                                          item.monto
                                            .toString()
                                            .replace(",", "")
                                            .replace(".", ","),
                                          ",",
                                          ".",
                                          2
                                        )}
                                      </td>
                                      <td
                                        className="align-baseline text-center"
                                        style={{ border: "#055182 solid 1px" }}
                                      >
                                        {item.estatus === 1 ? (
                                          <i className="fa fa-check-double text-success">
                                            {" "}
                                            Pagada
                                          </i>
                                        ) : item.estatus === 2 ? (
                                          <i className="fas text-danger fa-exclamation-triangle">
                                            {" "}
                                            Verificando Pago
                                          </i>
                                        ) : item.estatus === 0 ? (
                                          <i className="fas text-danger fa-exclamation-triangle">
                                            {" "}
                                            Por Pagar
                                          </i>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td
                                        className="align-baseline text-center"
                                        style={{
                                          border: "#055182 solid 1px",
                                        }}
                                      >
                                        {item.status === 2 ? (
                                          <i className="fas text-info fa-unlock">
                                            {" "}
                                            Habilitado
                                          </i>
                                        ) : item.status === 3 ? (
                                          <i className="fa fa-lock text-danger">
                                            {" "}
                                            Inhabilitado
                                          </i>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td
                                        className="align-baseline text-center"
                                        style={{
                                          border: "#055182 solid 1px",
                                          width: 150,
                                        }}
                                      >
                                        <button
                                          onClick={imprimirPago(item)}
                                          disabled={
                                            item.estatus !== 0 ? false : true
                                          }
                                          className="btn btn-sm  btn-danger rounded-circle ml-2"
                                        >
                                          <i className="fa fa-print"></i>{" "}
                                        </button>
                                        <button
                                          onClick={imprimirSolvencia(item)}
                                          disabled={
                                            item.estatus === 1 ? false : true
                                          }
                                          className={
                                            crudtimbreelectro.substring(
                                              1,
                                              2
                                            ) === "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-info rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-print"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(4, item)}
                                          className={
                                            crudtimbreelectro.substring(
                                              3,
                                              4
                                            ) === "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-info rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-eye"></i>{" "}
                                        </button>
                                                                                <button
                                          onClick={gestionarSolicitud(2, item)}
                                          disabled={
                                            item.status !== 0 ? false : true
                                          }
                                          className={
                                            crudtimbreelectro.substring(
                                              2,
                                              3
                                            ) === "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-success rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-edit"></i>{" "}
                                        </button>
                                        <button
                                          onClick={gestionarSolicitud(3, item)}
                                          disabled={
                                            item.estatus === 0 ? false : true
                                          }
                                          className={
                                            crudtimbreelectro.substring(
                                              3,
                                              4
                                            ) === "0"
                                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                              : "btn btn-sm mx-1 btn-danger rounded-circle"
                                          }
                                        >
                                          <i className="fa fa-trash"></i>{" "}
                                        </button>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </TblContainer>
                          <TblPagination />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={() =>
          setToast({ mostrar: false, titulo: "", mensaje: "" })
        }
      />
      <SolicitudTimbre
        show={mostrar2}
        /*         entes={entes}
        dependencias={dependencias}
        tramites={tramites} */
        valorut={valorut}
        operacion={operacion}
        solicitud={solvencia}
        onHide={ocultarModal}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default TimbreFiscalElectronico;



// WEBPACK FOOTER //
// ./src/pages/timbre_fiscal_electronico.js